import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { AppointmentConfirmation } from 'src/app/shared/models/response/appointment-confirmation';
import { MessageService } from 'primeng/api';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { WebStorageService } from 'src/app/shared/services/web-storage.service';
import { forkJoin, fromEvent, Subject } from 'rxjs';
import { SafeUrl } from '@angular/platform-browser';
import { finalize, takeUntil } from 'rxjs/operators';
import { SalesOrderLocalModel } from '../../shared/models/response/sales-order-current';
import { Router } from '@angular/router';
import { BTSalesOrderUpdateRequestModel } from 'src/app/shared/models/request/salesorder-update-request-model-brightree';
import { AppointmentCancelRequest } from 'src/app/shared/models/request/appointment-cancel-request';
import { SalesOrderResponseModel } from 'src/app/shared/models/response/sales-order-response';
import { WipStatusBTmapping } from 'src/app/shared/models/common/wip-status';
import moment from 'moment';
import { PatientService } from '../services/patient.service';
import { google, outlook, yahoo } from 'calendar-link';
import {
  SalesOrderHistoryCountModel,
  SelfSchedulingConfigModel,
  SelfSchedulingGeneralSetupModel,
  SelfSchedulingWrapper
} from 'src/app/shared/models/response/settings/self-scheduling-config-model';
import { SelfSchedulingConfigService } from 'src/app/admin/servicies/self-scheduling-config-service';
import { WipStatusBtService } from 'src/app/services/wip-status-bt.service';
import { PaymentService } from 'src/app/shared/services/payment.service';
import { PaymentResponseModel } from 'src/app/interfaces/payment-response';
import { PaymentSetupRequestModel } from 'src/app/interfaces/payment-integration';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CollectPaymentComponent } from 'src/app/shared/collect-payment/collect-payment.component';
import { ApplicableFor, PaymentFlowType } from 'src/app/interfaces/payment-enums';
import { marker } from 'src/app/interfaces/marker';
import { AdminSettingsService } from 'src/app/admin/servicies/admin-settings.service';
import { CancelFeesInfo } from 'src/app/interfaces/cancel-fees-info';
import nextbillion, { Map, Marker, NBMap, LngLatBounds, Popup } from '@nbai/nbmap-gl';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-appointment-confirmation',
  templateUrl: './appointment-confirmation.component.html',
  styleUrls: ['./appointment-confirmation.component.sass'],
  standalone: false
})
export class AppointmentConfirmationComponent extends BaseComponent implements OnInit, OnDestroy {
  private unsubscriber = new Subject<boolean>();
  Addtocalendar: { name: string; code: string }[];
  appointmentConfirmation: AppointmentConfirmation;
  appointmentStartDate: Date;
  appointmentEndDate: Date;
  appointmentTimeZone: string = '';
  appointmentTimeZoneCode: string;
  duration: string;
  description: string;
  facilityName: string;
  facilityAddress: string;
  facilityAddressLine1: string;
  facilityAddressLine2: string;
  facilityCity: string;
  facilityState: string;
  facilityCountry: string;
  facilityZipCode: string;
  facilityLatitude: number;
  facilityLongitude: number;
  crmBioData: string;
  distance: string;
  dueAmount: number;
  dateFormat: string;
  selectedName: { name: string; code: string };
  durationInMinutes: number;
  therapistName: string;
  selectedRemoteAppointmentType: string;
  selectedAppointmentTypePopUp: string;
  patientBookingTypeId: string = '';
  isTherapistFacilityType: boolean;
  isTherapistRemoteType: boolean;
  isTherapistRemoteAndFaciltyType: boolean;
  DMENumber: string;
  ShowDueAmount: boolean = false;
  ShowDeliveryNote: boolean = false;
  showFacilityAddress: boolean = false;
  public googleCalendarEventUrl: SafeUrl;
  salesOrderLocal: SalesOrderLocalModel;
  patientName: string;
  patientLatitude: number;
  patientLongitude: number;
  patientAddress: string;
  email: string = '';
  patientPhone: string = '';
  patientMobileNumber: string = '';
  salesOrderData: SalesOrderResponseModel;
  wipStatusBTMappingResponseModel: WipStatusBTmapping[];
  markers: marker[] = [];
  zoom: number = 8;
  loadingCustom: boolean;

  activeStepNo: number = 1;
  appointmentTitle: string;
  appointmentSelectLabel: string;
  ShowRescheduleButton: boolean = false;
  ShowCancelButton: boolean = false;
  lat: number = 51.673858;
  lng: number = 7.815982;
  RescheduleAppointment: boolean = false;
  CancelAppointment: boolean = false;
  cancelnote: string;
  schAppointmentId: number;
  schIsReminderOptedSms: boolean;
  schIsReminderOptedEmail: boolean;

  model = {} as SelfSchedulingWrapper;
  modelConfig = {} as SelfSchedulingConfigModel;
  modelsetup = {} as SelfSchedulingGeneralSetupModel;

  isPaymentApplicable = this.webStorageService.getIsPaymentApplicable();
  paymentResponseModel: PaymentResponseModel;
  paymentStepName = this.webStorageService.getPaymentStepName();
  hasExistingCard: boolean = false;
  paymentIntegrationSetting: any;
  cancelFeesInfo: CancelFeesInfo;

  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef;
  latLong: string = "34.08572,-118.324569";
  map!: Map;
  key: string = environment.nextBillionApiKey;
  constructor(
    messageService: MessageService,
    private webStorageService: WebStorageService,
    private patientService: PatientService,
    private configService: SelfSchedulingConfigService,
    private router: Router,
    private wipStatusBtService: WipStatusBtService,
    private paymentService: PaymentService,
    private dialogService: DialogService,
    private settingsService: AdminSettingsService

  ) {
    super(messageService);

    let settingResult = this.webStorageService.getPatientSalesOrderSettings();
    if (settingResult) {
      this.dateFormat = settingResult.dateFormat;
      if (settingResult.showDueAmount.toLowerCase() === 'true') this.ShowDueAmount = true;
      else this.ShowDueAmount = false;

      if (settingResult.showDeliveryNote.toLowerCase() === 'true') this.ShowDeliveryNote = true;
      else this.ShowDeliveryNote = false;
    }

    this.patientBookingTypeId = this.webStorageService.getPatientBookingTypeId();

    this.salesOrderData = this.webStorageService.getSalesOrderData();
    this.patientName = this.salesOrderData?.patientInfo?.crmPatientFirstName + ' ' + this.salesOrderData?.patientInfo?.crmPatientLastName;

    let onlineAppointmentTypeResponseModel = this.webStorageService.getOnlineAppointmentTypeNames();

    if (onlineAppointmentTypeResponseModel.length > 0) {
      if (this.patientBookingTypeId == 'R') {
        let RemoteSetup = onlineAppointmentTypeResponseModel.find((x) => x.crmOnlineAppointmentType == 'RemoteSetup');
        if (RemoteSetup) {
          this.appointmentTitle = RemoteSetup.crmOnlineAppointmentTitle;
          this.appointmentSelectLabel = 'Select Remote';
        }
      } else if (this.patientBookingTypeId == 'T') {
        let TherapistVisit = onlineAppointmentTypeResponseModel.find((x) => x.crmOnlineAppointmentType == 'TherapistVisit');
        if (TherapistVisit) {
          this.appointmentTitle = TherapistVisit.crmOnlineAppointmentTitle;
          this.appointmentSelectLabel = 'Select Therapist';
        }
      } else if (this.patientBookingTypeId == 'SG') {
        let SelfGuided = onlineAppointmentTypeResponseModel.find((x) => x.crmOnlineAppointmentType == 'SelfGuided');
        if (SelfGuided) {
          this.appointmentTitle = SelfGuided.crmOnlineAppointmentTitle;
          this.appointmentSelectLabel = 'Self Guided';
        }
      } else if (this.patientBookingTypeId == 'F') {
        let FacilityVisit = onlineAppointmentTypeResponseModel.find((x) => x.crmOnlineAppointmentType == 'FacilityVisit');
        if (FacilityVisit) {
          this.appointmentTitle = FacilityVisit.crmOnlineAppointmentTitle;
          this.appointmentSelectLabel = 'Select Clinic';
        }
      }
    }
    this.activeStepNo = 1;
  }


  private initMap() {
    if (!this.mapContainer?.nativeElement) {
      console.error('Map container not available');
      return;
    }

    try {
      nextbillion.setApiKey(this.key);

      this.map = new Map({
        container: this.mapContainer.nativeElement,
        style: `https://api.nextbillion.io/maps/streets/style.json?key=${this.key}`,
        zoom: 7,
        attributionControl: false,
        center: {
          lat: this.facilityLatitude || 34.08572,
          lng: this.facilityLongitude || -118.124569
        }
      });

      this.map.on('load', () => {
        console.log('Map loaded successfully');
        this.addCustomMarkerWithDom(this.map);
      });

      this.map.on('error', (error) => {
        console.error('Map error:', error);
      });

    } catch (error) {
      console.error('Error initializing map:', error);
    }
  }

  addCustomMarkerWithDom(map: Map) {
    if (!map) {
      console.error('Map instance not provided');
      return;
    }

    const createMarkerElement = (label: string, bgColor: string = '#ff4444'): HTMLElement => {
      const el = document.createElement('div');
      el.className = 'marker';
      el.style.backgroundColor = bgColor;
      el.style.color = 'white';
      el.style.borderRadius = '50%';
      el.style.width = '36px';
      el.style.height = '36px';
      el.style.display = 'flex';
      el.style.alignItems = 'center';
      el.style.justifyContent = 'center';
      el.style.fontSize = '16px';
      el.style.fontWeight = 'bold';
      el.style.border = '2px solid white';
      el.style.boxShadow = '0 2px 4px rgba(0,0,0,0.3)';
      el.innerHTML = label;
      return el;
    };

    const markersData = [
      { lat: this.facilityLatitude, lng: this.facilityLongitude, label: 'F', popupText: 'Facility' },
      { lat: this.patientLatitude, lng: this.patientLongitude, label: 'P', popupText: 'Patient' }
    ];

    const bounds = new LngLatBounds();

    markersData.forEach(m => {
      try {
        const popup = new Popup({ offset: 10, closeButton: false }).setText(m.popupText);
        const markerEl = createMarkerElement(m.label);
        const marker = new Marker({ element: markerEl })
          .setLngLat({ lat: m.lat, lng: m.lng })
          .setPopup(popup)
          .addTo(map);

        marker.togglePopup();
        bounds.extend([m.lng, m.lat]);
      } catch (error) {
        console.error('Error adding marker:', error, m);
      }
    });

    try {
      if (!bounds.isEmpty()) {
        map.fitBounds(bounds, { padding: 50 });
      }
    } catch (error) {
      console.error('Error fitting bounds:', error);
    }
  }

  ngOnInit() {
    this.getWipStatusBTmapping();
    this.loadData();
    history.pushState(null, '');
    fromEvent(window, 'popstate')
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((_) => {
        history.pushState(null, '');
      });

    this.Addtocalendar = [
      { name: 'Select Calendar', code: 'S' },
      { name: 'Google', code: 'G' },
      { name: 'Yahoo', code: 'Y' },
      { name: 'Outlook', code: 'O' }
    ];

    this.salesOrderLocal = this.webStorageService.getSalesOrderId();
    if (!this.salesOrderLocal) {
      let url = this.webStorageService.getPatientBookingUrl().split('?')[0].split('home/')[1];
      this.router.navigate(['/patient/home/' + url], { queryParams: { utm_source: 'email' } });
    }

    this.patientName = this.webStorageService.getPatientName();
    this.salesOrderData = this.webStorageService.getSalesOrderData();
    this.patientBookingTypeId = this.webStorageService.getPatientBookingTypeId();
    this.showFacilityAddress = this.patientBookingTypeId == 'T' && !this.isTherapistRemoteType ? true : this.patientBookingTypeId == 'F' ? true : false;

    if (!this.salesOrderLocal) {
      this.showWarningMessage('No sales order selected.');
    }
    this.email = this.salesOrderLocal?.patientEmail;
    this.patientPhone = this.salesOrderLocal?.patientPhone;
    this.patientMobileNumber = this.salesOrderLocal?.patientMobile;

    this.appointmentConfirmation = new AppointmentConfirmation();
    this.appointmentConfirmation = this.webStorageService.getAppointmentConfirmation();
    this.DMENumber = this.webStorageService.getDMENumber();
    this.loading = true;
    if (this.appointmentConfirmation) {
      this.appointmentStartDate = this.appointmentConfirmation.appointmentStartDate;
      this.appointmentEndDate = this.appointmentConfirmation.appointmentEndDate;
      this.appointmentTimeZone = this.appointmentConfirmation.appointmentTimeZone;
      this.appointmentTimeZoneCode = this.appointmentConfirmation.appointmentTimeZoneCode;
      this.description = this.appointmentConfirmation.description;
      this.distance = this.appointmentConfirmation.distance;
      this.duration = this.appointmentConfirmation.duration;
      this.facilityAddress = this.appointmentConfirmation.facilityAddress;
      this.facilityAddressLine1 = this.appointmentConfirmation.facilityAddressLine1;
      this.facilityAddressLine2 = this.appointmentConfirmation.facilityAddressLine2;
      this.facilityCity = this.appointmentConfirmation.facilityCity;
      this.facilityState = this.appointmentConfirmation.facilityState;
      this.facilityCountry = this.appointmentConfirmation.facilityCountry;
      this.facilityZipCode = this.appointmentConfirmation.facilityZipCode;
      this.facilityName = this.appointmentConfirmation.facilityName;
      this.facilityLatitude = this.appointmentConfirmation.facilityLatitude;
      this.facilityLongitude = this.appointmentConfirmation.facilityLongitude;
      this.crmBioData = this.appointmentConfirmation.crmBioData;
      this.dueAmount = this.appointmentConfirmation.dueAmount;
      this.durationInMinutes = this.appointmentConfirmation.durationInMinutes;
      this.therapistName = this.appointmentConfirmation.crmTherapistname;
      this.selectedRemoteAppointmentType = this.appointmentConfirmation.remoteType;
      this.isTherapistFacilityType = this.appointmentConfirmation.isTherapistFacilityType;
      this.isTherapistRemoteType = this.appointmentConfirmation.isTherapistRemoteType;
      this.isTherapistRemoteAndFaciltyType = this.appointmentConfirmation.isTherapistRemoteAndFaciltyType;
      this.selectedAppointmentTypePopUp =
        this.appointmentConfirmation.selectedAppointmentTypePopUp.toLowerCase() == 'ClinicVisit'.toLowerCase() ? 'Clinic Visit' : 'Remote Setup';
      this.email = this.appointmentConfirmation.PatientEmail;
      this.patientPhone = this.appointmentConfirmation.PatientPhone.replaceAll('-', '');
      this.patientMobileNumber = this.appointmentConfirmation.PatientMobileNumber.replaceAll('-', '');
      this.patientLatitude = this.salesOrderData.patientInfo.crmLatitude;
      this.patientLongitude = this.salesOrderData.patientInfo.crmLongitude;
      this.patientAddress = this.salesOrderData.patientInfo.crmPatientAddress;
      this.schAppointmentId = this.appointmentConfirmation.schAppointmentId;
      this.schIsReminderOptedEmail = this.appointmentConfirmation.schIsReminderOptedEmail;
      this.schIsReminderOptedSms = this.appointmentConfirmation.schIsReminderOptedSms;

      setTimeout(() => {
        this.initMap();
      }, 200);
      if (this.isTherapistFacilityType || this.patientBookingTypeId == 'F') {
        this.markers = [
          {
            lat: this.facilityLatitude,
            lng: this.facilityLongitude,
            label: this.facilityName,
            draggable: false,
            type: 'F',
            address: this.facilityAddress
          },
          {
            lat: this.salesOrderData.patientInfo.crmLatitude,
            lng: this.salesOrderData.patientInfo.crmLongitude,
            label: this.patientName,
            draggable: false,
            type: 'P',
            address: this.patientAddress
          }
        ];
      }
    } else {
      this.showErrorMessage('No appointment is scheduled.');
    }

    this.webStorageService.deleteSelectedFacilies();
    this.webStorageService.deleteSalesOrderId();
    this.webStorageService.deleteAppointmentConfirmation();
    this.loading = false;

    this.paymentService.paymentCompletedPatient$.pipe(takeUntil(this.unsubscriber)).subscribe((paymentResponse) => {
      if (paymentResponse && paymentResponse.isSuccess) {
        this.paymentResponseModel = paymentResponse;
      }
    });
  }

  async loadData() {
    try {
      const [historyResult, configResult] = await forkJoin([
        this.configService.getSalesorderHistoryCount(this.salesOrderData.crmSalesorderId),
        this.configService.getAll()
      ]).toPromise();

      let salesOrderHistoryCountModel = new SalesOrderHistoryCountModel();
      this.processResult<SalesOrderHistoryCountModel>(historyResult, () => {
        if (historyResult.isSuccess && historyResult.responseModel) {
          salesOrderHistoryCountModel = historyResult.responseModel;
        }
      });

      this.model = configResult.responseModel;

      let branch = false,
        classification = false,
        insurance = false;
      this.modelConfig = null;
      this.model.configs.find((x) => x.isDefault);

      this.model.configs.forEach((element) => {
        if (!element.isDefault) {
          branch = element?.jsonValue?.branchIds?.split(',').includes(this.salesOrderData?.crmBranchId.toString());
          classification = element?.jsonValue?.classificationIds?.split(',').includes(this.salesOrderData?.crmSalesorderClassificationType.toString());
          const insuranceIds = element?.jsonValue?.insuranceIds?.split(',');
          insurance = insuranceIds?.some((id) => this.salesOrderData?.salesOrderInsuranceInfo?.some((info) => info.crmPolicyHolderName.toString() === id));

          if (branch && classification && insurance) {
            this.modelConfig = element;
            return;
          }
        }
      });

      this.modelsetup = this.model.setup;
      if (this.modelsetup?.isEnabled && this.modelConfig == null) {
        this.modelConfig = this.model.configs.find((x) => x.isDefault);
      }

      this.ShowCancelButton =
        this.modelConfig?.jsonValue?.isCancellationAllowed &&
        (!this.modelConfig?.jsonValue?.isLimitNoOfCancelAppointments || salesOrderHistoryCountModel?.canceledCount < this.modelConfig?.jsonValue?.maxCancelAllowed);

      this.ShowRescheduleButton =
        this.modelConfig?.jsonValue?.isRescheduleAllowed &&
        (!this.modelConfig?.jsonValue?.isLimitNoOfRescheduleAppointments ||
          salesOrderHistoryCountModel?.rescheduleCount < this.modelConfig?.jsonValue?.maxRescheduleAllowed);

      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.showErrorMessage(error.message);
    }
  }

  onEventClick() {
    if (this.selectedName.code === 'S') {
      return;
    }
    const event = {
      title: 'Appointment booked',
      description: this.description,
      start: new Date(this.appointmentStartDate),
      end: new Date(this.appointmentEndDate),
      duration: [this.durationInMinutes, 'minute'] as [number, 'second' | 'minute' | 'hour' | 'day'],
      location: this.facilityAddress
    };
    let googleLink = google(event);
    let yahooLink = yahoo(event);
    let outlookLink = outlook(event);
    setTimeout(() => {
      if (this.selectedName.code === 'G') {
        window.open(googleLink, '_blank');
      } else if (this.selectedName.code === 'O') {
        window.open(outlookLink, '_blank');
      } else if (this.selectedName.code === 'Y') {
        window.open(yahooLink, '_blank');
      }
    }, 0);
  }

  ngOnDestroy() {
    if (this.unsubscriber) {
      this.unsubscriber.next();
      this.unsubscriber.complete();
    }
  }

  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`);
  }

  markerDragEnd(m: marker, $event: MouseEvent) {
  }

  onBack() {
    this.paymentService.paymentCompletedPatient$.next(null);
    this.webStorageService.deleteAppointmentConfirmation();
    let url = this.webStorageService.getPatientBookingUrl().split('?')[0].split('home/')[1];
    this.router.navigate(['/patient/home/' + url], { queryParams: { utm_source: 'rescheduleappointment' } });
  }

  private buildCancelRequestModel(): AppointmentCancelRequest {
    const cancelRequestModel = new AppointmentCancelRequest();
    cancelRequestModel.modifiedByUserInfoId = this.salesOrderData.patientInfo.crmPatientId;
    cancelRequestModel.schAppointmentId = this.schAppointmentId;
    cancelRequestModel.schCancelReason = 'Other';
    cancelRequestModel.schComments = this.cancelnote;

    let cancelAppointmentRequestBT = new BTSalesOrderUpdateRequestModel();
    cancelAppointmentRequestBT.IsUpdateToBrightree = false;
    cancelAppointmentRequestBT.IsDeliveryNoteOverride = true;
    cancelAppointmentRequestBT.IsOrderNoteOverride = true;
    cancelAppointmentRequestBT.OrderNote = null;
    cancelAppointmentRequestBT.DeliveryNote = null;
    cancelAppointmentRequestBT.PractitionerName = null;
    cancelAppointmentRequestBT.PractitionerId = 0;
    cancelAppointmentRequestBT.ScheduledDeliveryStartDateString = null;
    cancelAppointmentRequestBT.ScheduledDeliveryStartTimeString = null;
    cancelAppointmentRequestBT.ScheduledDeliveryStartDate = null;
    cancelAppointmentRequestBT.WIPDateNeededString = moment().toDate().toDateString();
    cancelAppointmentRequestBT.WIPDateNeeded = moment().toDate();
    if (this.wipStatusBTMappingResponseModel != null && this.wipStatusBTMappingResponseModel != undefined) {
      let selectedWipStaus = this.wipStatusBTMappingResponseModel.find((x) => x.crmWipstatusNameSa.toLowerCase() == 'cancel');
      if (selectedWipStaus) {
        cancelAppointmentRequestBT.WIPStateName = selectedWipStaus.crmWipstatusNameBt;
        cancelAppointmentRequestBT.WIPStateKey = selectedWipStaus.wipStatusRCMId;
        cancelAppointmentRequestBT.IsUpdateToBrightree = selectedWipStaus.crmIsUpdateToBrigthree;
        cancelAppointmentRequestBT.WIPAssignedToKey = selectedWipStaus.crmWIPAssignedToKey;
      }
    }

    cancelRequestModel.salesOrderUpdateRequestModelBT = cancelAppointmentRequestBT;
    cancelRequestModel.isCancelledByPatient = true;
    return cancelRequestModel;
  }

  processCancellation() {
    this.loadingCustom = true;
    this.CancelAppointment = false;
    this.loading = true;
    this.patientService
      .CancelAppointment(this.buildCancelRequestModel())
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .subscribe((result) => {
        if (result.responseModel) {
          this.webStorageService.deleteAppointmentId();
          this.showSuccessMessage('Appointment has been canceled.');
          this.loadingCustom = false;
          let url = this.webStorageService.getPatientBookingUrl().split('?')[0].split('home/')[1];
          this.router.navigate(['/patient/home/' + url], { queryParams: { utm_source: 'email' } });
        } else {
          this.loadingCustom = false;
          if (result.message) this.showErrorMessage(result.message);
          else this.showErrorMessage('There was problem in cancelling your appointment.');
        }
      });
  }


  onCancel() {
    if (this.cancelFeesInfo?.chargeCancelFees && this.cancelFeesInfo?.amount > 0) {
      this.handleCancellationWithFee();
    }
    else {
      this.processCancellation();
    }
  }

  private async handleCancellationWithFee() {
    this.loading = true;
    try {
      const paymentInfo = await this.getPaymentInformation();
      this.hasExistingCard = paymentInfo?.paymentCard !== null;
      await this.openPaymentDialog();
    } catch (error) {
      this.loading = false;
      this.showErrorMessage('Failed to process cancellation fee. Please try again.');
    }
  }

  private openPaymentDialog() {
    let dialogRef: DynamicDialogRef;
    const requestData: PaymentSetupRequestModel = {
      salesOrderId: this.salesOrderData.crmSalesorderId,
      appointmentCancelRequest: this.buildCancelRequestModel(),
      applicableFor: ApplicableFor.Patient,
      flowType: PaymentFlowType.CancelFees
    };

    dialogRef = this.dialogService.open(CollectPaymentComponent, {
      header: 'Cancellation Fee Payment',
      width: '700px',
      height: '80%',
      modal: true,
      closable: true,
      data: {
        salesOrderId: this.salesOrderData.crmSalesorderId,
        flowType: PaymentFlowType.CancelFees,
        applicableFor: ApplicableFor.Patient,
        cancellationFeeRequest: requestData
      },
      styleClass: 'cancellation-fee-dialog'
    });

    dialogRef.onClose.subscribe((response: PaymentResponseModel) => {
      if (response && response?.isSuccess && (response?.paymentFlowType === PaymentFlowType.CancelFees)) {
        this.CancelAppointment = false;
        this.webStorageService.deleteAppointmentId();
        this.router.navigate(['/patient/booked-appointment']);
      }
      const paymentSetup = this.webStorageService.getPaymentSetup();
      if (paymentSetup) {
        this.paymentService.clearPaymentSetup(paymentSetup).subscribe(() => {
          this.webStorageService.deletePaymentSetup();
        });
      }
    });
  }

  private async getPaymentInformation(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.paymentService.getPaymentInformation(this.salesOrderData.crmSalesorderId).subscribe({
        next: (result) => resolve(result.responseModel),
        error: (error) => reject(error)
      });
    });
  }

  getWipStatusBTmapping() {
    this.wipStatusBtService.getMappings().subscribe((result) => {
      this.wipStatusBTMappingResponseModel = result.responseModel;
    });
  }

  rescheduleAppointmentBtn() {
    this.paymentService.paymentCompletedPatient$.next(null);
    this.RescheduleAppointment = true;
  }

  async cancelAppointmentBtn() {
    const appointmentId = this.webStorageService.getAppointmentId();
    console.log(appointmentId);
    this.loading = true;
    await this.patientService.GetCancelFeesInfo(appointmentId)
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => (this.loading = false))
      )
      .toPromise()
      .then((result) => {
        this.processResult<CancelFeesInfo>(result, () => {
          if (result.isSuccess) {
            if (result.responseModel) {
              this.cancelFeesInfo = result.responseModel;
              this.CancelAppointment = true;
            }
          }
        });
      }, error => {
        this.loading = false;
        this.showErrorMessage(error.message);
      });
  }
}
